function startCountdown(deadline) {
            function updateCountdown() {
                const now = new Date().getTime();
                const timeLeft = deadline - now;
                
                if (timeLeft <= 0) {
                    document.getElementById('countdown-container').style.display = 'none';
                    return;
                }

                const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
                const hours = String(Math.floor((timeLeft / (1000 * 60 * 60)) % 24)).padStart(2, '0');
                const minutes = String(Math.floor((timeLeft / (1000 * 60)) % 60)).padStart(2, '0');
                const seconds = String(Math.floor((timeLeft / 1000) % 60)).padStart(2, '0');

                document.getElementById('days').textContent = days;
                document.getElementById('hours').textContent = hours;
                document.getElementById('minutes').textContent = minutes;
                document.getElementById('seconds').textContent = seconds;
              
                if (days <= 2) {
                    document.getElementById('countdown-container').style.display = 'block';
                } else {
                    document.getElementById('countdown-container').style.display = 'none';
                }
            }
            
            updateCountdown();
            setInterval(updateCountdown, 1000);
        }
        
        // Pobranie daty z Shopify Liquid
        const orderDeadline = document.getElementById('countdown-container').getAttribute('data-deadline');
        console.log(orderDeadline)
        if (orderDeadline) {
            startCountdown(new Date(orderDeadline).getTime());
        }